export default __webpack_public_path__ + "static/media/quickstart-beauty.b62a7cd2.png";